/**
 * Alkalmazás szintű konstansok
 */

// Route nevek
export const ROUTES = {
    SEARCH: 'default',
    LIST: 'list',
    DETAILS: 'details'
};

// Beadvány típusok
export const SUBMISSION_TYPES = [
    { value: '', label: '' },
    { value: 'szakindítás', label: 'Szakindítás' },
    { value: 'szaklétesítés', label: 'Szaklétesítés' },
    { value: 'egyetemi tanári pályázat', label: 'Egyetemi tanári pályázat' }
];

// Alapértelmezett lapozási beállítások
export const DEFAULT_PAGINATION = {
    currentPage: 1,
    pageSize: 10,
    totalPages: 1,
    totalRecords: 0
};

